import { Component } from 'preact'
import Button from '@insided/control/uikit/Button'
import { UnifiedTopic, performBulkActionForTopics } from '../../utils'
/* eslint-disable import/no-internal-modules */
import { BulkActionComponentProps } from '@insided/deprecated-control/overview'

class MarkAsReadByTeam extends Component<BulkActionComponentProps, {}> {
  render() {
    const { performBulkAction } = this.props

    return (
      <div>
        <Button
          title='Mark as read by team'
          size='medium'
          variant='secondary'
          data-qa='mark-as-read-by-team'
          startIcon='read'
          onClick={() =>
            performBulkAction({
              onClick: async (topics: UnifiedTopic[]) => {
                return await performBulkActionForTopics(topics, 'markAsReadByTeam')
              },
              successMessage: 'Topic(s) marked as read by team.'
            })}
        />
      </div>
    )
  }
}

export default MarkAsReadByTeam
